// Talks to the MegaCom DCB gateway (send-pin / verify-pin / unsubscribe / status / plans).
// The gateway always answers 200 with { message, status, code, data } - `status` is the
// single source of truth for success, `message` is already localized server-side based on
// the Accept-Language header we send (gateway supports "ru" and "ky", defaults to English).
const SERVICE_ABBREVIATION = 'KS';
const LANDING_PAGE_NAME = 'Kid Security Main - MegaCom KG';

class ApiSender {
  constructor() {
    this.baseUrl = process.env.REACT_APP_GTW_BASE_URL;
  }

  async request(method, path, { payload, language } = {}) {
    const headers = {
      'Accept-Language': (language || 'RU').toLowerCase(),
    };

    if (payload) {
      headers['Content-Type'] = 'application/json';
    }

    try {
      const response = await fetch(`${this.baseUrl}${path}`, {
        method,
        headers,
        body: payload ? JSON.stringify(payload) : undefined,
      });

      const result = await response.json().catch(() => null);

      return { ok: response.ok, result };
    } catch (error) {
      console.error(`Request to ${path} failed:`, error);
      return { ok: false, result: null, error };
    }
  }

  post(path, payload, language) {
    return this.request('POST', path, { payload, language });
  }

  get(path, language) {
    return this.request('GET', path, { language });
  }

  isSuccess(response) {
    return Boolean(response?.ok && response.result?.status === true);
  }

  sendPin({ msisdn, planId, language, location }) {
    const payload = {
      msisdn,
      planId,
      language,
      lpUrl: window.location.origin + location.pathname,
      lpName: LANDING_PAGE_NAME,
      queryParams: location.search?.length > 1 ? location.search.substring(1) : null,
      service: SERVICE_ABBREVIATION,
    };

    return this.post('/send-pin', payload, language);
  }

  verifyPin({ msisdn, otp, planId, language, location }) {
    const payload = {
      msisdn,
      otp,
      planId,
      language,
      lpUrl: window.location.origin + location.pathname,
      lpName: LANDING_PAGE_NAME,
      queryParams: location.search?.length > 1 ? location.search.substring(1) : null,
      service: SERVICE_ABBREVIATION,
    };

    return this.post('/verify-pin', payload, language);
  }

  unsubscribe({ msisdn, language }) {
    return this.post('/unsubscribe', { msisdn, language }, language);
  }

  status({ msisdn, language }) {
    return this.post('/status', { msisdn, language }, language);
  }

  getPlans(language) {
    return this.get('/plans', language);
  }

  getBrowserLang(fallback = 'RU') {
    if (typeof navigator === 'undefined') {
      return fallback;
    }

    const raw =
      navigator.languages?.[0] ||
      navigator.language ||
      navigator.userLanguage;

    const lang = raw?.split('-')?.[0]?.toUpperCase();

    return ['RU', 'KY', 'EN'].includes(lang) ? lang : fallback;
  }
}

export default ApiSender;
